import React, { useRef, useEffect } from "react";
import "./Divider.css";
import imgArrow from "../../assets/image/arrow-one.png";
import gsap from "gsap";
import Running from "../../components/runner/Runner";
import { useHistory } from "react-router-dom";
// import Running from '../../components/textRun/Text_run';

const Divider = () => {
  const history = useHistory();
  const navigateToAbout = () => {
    history.push("/profile");
  };
  const navigateToGallery = () => {
    history.push("/gallery")
  }
  const navigateToContact = () => {
    history.push("/kontak")
  }

  return (
    <>
      <section className='container-divider w-full grid items-center'>
        <div className='content-row-div grid lg:grid-cols-3 md:grid-cols-3'>
          <div
            className='box-divider-cols relative cursor-pointer'
            onClick={navigateToAbout}
          >
            <p className='lg:text-8xl sm:text-7xl'>About</p>
            <img
              src={imgArrow}
              alt=''
              srcset=''
              className='img-top'
              // ref={arrowDiv}
            />
          </div>
          <div className='box-divider-cols relative' onClick={navigateToGallery}>
            <p className='lg:text-8xl sm:text-7xl'>Events</p>
            <img
              src={imgArrow}
              alt=''
              srcset=''
              className='img-top'
              // ref={arrowDiv}
            />
          </div>
          <div className='box-divider-cols relative' onClick={navigateToContact}>
            <p className='lg:text-8xl sm:text-7xl'>Contact</p>
            <img
              src={imgArrow}
              alt=''
              srcset=''
              className='img-top'
              // ref={arrowDiv}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Divider;
